// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Assets/HomeImage.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.panel-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    overflow: hidden;
    position: relative;
}
.projects-wrapper {
    display: flex;
    gap: 20px;
    overflow-x: auto;
    overflow-y: hidden;
    scroll-behavior: smooth;
    width: 100%;
    padding: 20px;
    scrollbar-width: none;
    -ms-overflow-style: none;
}
.projects-wrapper::-webkit-scrollbar {
    display: none;
}
.project {
    min-width: 350px;
    height: 400px;
    background-color: rgba(0, 0, 0, 0.76);
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
    background-blend-mode: darken;
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    position: relative;
    padding: 20px;
    padding-bottom: 40px;
    padding-top: 40px;
    transition: height 0.3s ease;
    box-sizing: border-box;
}
.by-date {
    font-size: 50px;
    min-width: 350px;
    background-color: #333;
    color: #e6341c;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    padding: 20px;
    padding-bottom: 40px;
    box-sizing: border-box;
}
.project.active {
    transform: scale(1.2);
    z-index: 10;
    padding: 20px;
    padding-top: 40px;
}
.project.active .project-name {
    flex-grow: 0;
    margin-bottom: 20px;
}
.project.active .project-description {
    opacity: 1;
    margin-top: 10px;
    margin-left: 14px;
    margin-right: 14px;
}
.project-name {
    font-weight: bold;
    font-size: 26px;
    margin-bottom: 0;
    transition: margin-bottom 0.3s ease;
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}
.project-description {
    font-size: 18px;
    opacity: 0;
    transition: opacity 0.3s ease, margin-top 0.3s ease;
    margin-top: 0;
}
.project-description a {
    font-size: 16px;
    color: rgb(66, 146, 250);
}
.icon-link {
    position: absolute;
    bottom: 20px;
    right: 15px;
    color: #fff;
    font-size: 24px;
    text-decoration: none;
}
.icon-link:hover {
    color: #e74c3c;
}
.hover-text {
    position: absolute;
    bottom: 50%;
    left: 50%;
    transform: translate(-50%, 50%);
    color: #fff;
    opacity: 0;
    transition: opacity 0.3s ease;
    text-align: center;
    font-size: 16px;
}
.scroll-btn-container {
    display: flex;
    justify-content: center;
    gap: 30px;
    margin-top: 60px;
}
.scroll-btn {
    transform: translateY(-40%);
    background-color: #111;
    color: #fff;
    border: none;
    cursor: pointer;
    z-index: 10;
    border-radius: 50%;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
    transition: all 0.3s ease;
    width: 70px;
    height: 70px;
    font-size: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.scroll-btn:hover {
    background-color: #e74c3c;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.5);
}
.scroll-btn:active {
    transform: scale(0.97);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.39);
}

@media (max-width: 1100px) {
    .project-name {
        font-size: 22px;
    }
    .project-description {
        font-size: 16px;
    }
    .project-description a {
        font-size: 14px;
    }
    .icon-link {
        font-size: 22px;
    }
    .project {
        min-width: 300px;
        height: 350px;
        border-radius: 10px;
        padding: 20px;
        padding-bottom: 40px;
        padding-top: 40px;
    }
    .by-date {
        min-width: 300px;
    }
}

@media (max-width: 480px) {
    .project-name {
        font-size: 16px;
    }
    .project-description {
        font-size: 14px;
    }
    .project-description a {
        font-size: 11px;
    }
    .icon-link {
        font-size: 18px;
    }
    .project {
        min-width: 250px;
        height: 315px;
        border-radius: 10px;
        padding: 15px;
        padding-bottom: 10px;
        padding-top: 10px;
    }
    .project.active {
        padding: 10px;
        padding-top: 10px;
    }
    .project.active .project-name {
        margin-bottom: 10px;
    }
    .project.active .project-description {
        opacity: 1;
        margin-top: 10px;
        margin-left: 10px;
        margin-right: 10px;
    }
    .by-date {
        min-width: 250px;
    }
    .scroll-btn {
        width: 60px;
        height: 60px;
        font-size: 28px;
    }
}

@media (max-width: 370px) {
    .project-name {
        font-size: 15px;
    }
    .project-description {
        font-size: 13px;
    }
    .project-description a {
        font-size: 10px;
    }
    .icon-link {
        font-size: 16px;
    }
    .project {
        min-width: 220px;
        height: 315px;
        border-radius: 10px;
        padding: 15px;
        padding-bottom: 10px;
        padding-top: 10px;
    }
    .project.active .project-name {
        margin-bottom: 10px;
    }
    .by-date {
        min-width: 220px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/HorizontalPanel.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;IACX,aAAa;IACb,qBAAqB;IACrB,wBAAwB;AAC5B;AACA;IACI,aAAa;AACjB;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,qCAAqC;IACrC,yDAAgD;IAChD,sBAAsB;IACtB,2BAA2B;IAC3B,6BAA6B;IAC7B,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,oBAAoB;IACpB,iBAAiB;IACjB,4BAA4B;IAC5B,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,oBAAoB;IACpB,sBAAsB;AAC1B;AACA;IACI,qBAAqB;IACrB,WAAW;IACX,aAAa;IACb,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,mCAAmC;IACnC,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,eAAe;IACf,UAAU;IACV,mDAAmD;IACnD,aAAa;AACjB;AACA;IACI,eAAe;IACf,wBAAwB;AAC5B;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,eAAe;IACf,qBAAqB;AACzB;AACA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,+BAA+B;IAC/B,WAAW;IACX,UAAU;IACV,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,2BAA2B;IAC3B,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,wCAAwC;IACxC,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,yBAAyB;IACzB,yCAAyC;AAC7C;AACA;IACI,sBAAsB;IACtB,yCAAyC;AAC7C;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,gBAAgB;QAChB,aAAa;QACb,mBAAmB;QACnB,aAAa;QACb,oBAAoB;QACpB,iBAAiB;IACrB;IACA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,gBAAgB;QAChB,aAAa;QACb,mBAAmB;QACnB,aAAa;QACb,oBAAoB;QACpB,iBAAiB;IACrB;IACA;QACI,aAAa;QACb,iBAAiB;IACrB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,UAAU;QACV,gBAAgB;QAChB,iBAAiB;QACjB,kBAAkB;IACtB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,gBAAgB;QAChB,aAAa;QACb,mBAAmB;QACnB,aAAa;QACb,oBAAoB;QACpB,iBAAiB;IACrB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".panel-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    overflow: hidden;\n    position: relative;\n}\n.projects-wrapper {\n    display: flex;\n    gap: 20px;\n    overflow-x: auto;\n    overflow-y: hidden;\n    scroll-behavior: smooth;\n    width: 100%;\n    padding: 20px;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n}\n.projects-wrapper::-webkit-scrollbar {\n    display: none;\n}\n.project {\n    min-width: 350px;\n    height: 400px;\n    background-color: rgba(0, 0, 0, 0.76);\n    background-image: url('../Assets/HomeImage.jpg');\n    background-size: cover;\n    background-position: center;\n    background-blend-mode: darken;\n    color: #fff;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    border-radius: 10px;\n    position: relative;\n    padding: 20px;\n    padding-bottom: 40px;\n    padding-top: 40px;\n    transition: height 0.3s ease;\n    box-sizing: border-box;\n}\n.by-date {\n    font-size: 50px;\n    min-width: 350px;\n    background-color: #333;\n    color: #e6341c;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    border-radius: 10px;\n    padding: 20px;\n    padding-bottom: 40px;\n    box-sizing: border-box;\n}\n.project.active {\n    transform: scale(1.2);\n    z-index: 10;\n    padding: 20px;\n    padding-top: 40px;\n}\n.project.active .project-name {\n    flex-grow: 0;\n    margin-bottom: 20px;\n}\n.project.active .project-description {\n    opacity: 1;\n    margin-top: 10px;\n    margin-left: 14px;\n    margin-right: 14px;\n}\n.project-name {\n    font-weight: bold;\n    font-size: 26px;\n    margin-bottom: 0;\n    transition: margin-bottom 0.3s ease;\n    flex-grow: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.project-description {\n    font-size: 18px;\n    opacity: 0;\n    transition: opacity 0.3s ease, margin-top 0.3s ease;\n    margin-top: 0;\n}\n.project-description a {\n    font-size: 16px;\n    color: rgb(66, 146, 250);\n}\n.icon-link {\n    position: absolute;\n    bottom: 20px;\n    right: 15px;\n    color: #fff;\n    font-size: 24px;\n    text-decoration: none;\n}\n.icon-link:hover {\n    color: #e74c3c;\n}\n.hover-text {\n    position: absolute;\n    bottom: 50%;\n    left: 50%;\n    transform: translate(-50%, 50%);\n    color: #fff;\n    opacity: 0;\n    transition: opacity 0.3s ease;\n    text-align: center;\n    font-size: 16px;\n}\n.scroll-btn-container {\n    display: flex;\n    justify-content: center;\n    gap: 30px;\n    margin-top: 60px;\n}\n.scroll-btn {\n    transform: translateY(-40%);\n    background-color: #111;\n    color: #fff;\n    border: none;\n    cursor: pointer;\n    z-index: 10;\n    border-radius: 50%;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n    transition: all 0.3s ease;\n    width: 70px;\n    height: 70px;\n    font-size: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.scroll-btn:hover {\n    background-color: #e74c3c;\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.5);\n}\n.scroll-btn:active {\n    transform: scale(0.97);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.39);\n}\n\n@media (max-width: 1100px) {\n    .project-name {\n        font-size: 22px;\n    }\n    .project-description {\n        font-size: 16px;\n    }\n    .project-description a {\n        font-size: 14px;\n    }\n    .icon-link {\n        font-size: 22px;\n    }\n    .project {\n        min-width: 300px;\n        height: 350px;\n        border-radius: 10px;\n        padding: 20px;\n        padding-bottom: 40px;\n        padding-top: 40px;\n    }\n    .by-date {\n        min-width: 300px;\n    }\n}\n\n@media (max-width: 480px) {\n    .project-name {\n        font-size: 16px;\n    }\n    .project-description {\n        font-size: 14px;\n    }\n    .project-description a {\n        font-size: 11px;\n    }\n    .icon-link {\n        font-size: 18px;\n    }\n    .project {\n        min-width: 250px;\n        height: 315px;\n        border-radius: 10px;\n        padding: 15px;\n        padding-bottom: 10px;\n        padding-top: 10px;\n    }\n    .project.active {\n        padding: 10px;\n        padding-top: 10px;\n    }\n    .project.active .project-name {\n        margin-bottom: 10px;\n    }\n    .project.active .project-description {\n        opacity: 1;\n        margin-top: 10px;\n        margin-left: 10px;\n        margin-right: 10px;\n    }\n    .by-date {\n        min-width: 250px;\n    }\n    .scroll-btn {\n        width: 60px;\n        height: 60px;\n        font-size: 28px;\n    }\n}\n\n@media (max-width: 370px) {\n    .project-name {\n        font-size: 15px;\n    }\n    .project-description {\n        font-size: 13px;\n    }\n    .project-description a {\n        font-size: 10px;\n    }\n    .icon-link {\n        font-size: 16px;\n    }\n    .project {\n        min-width: 220px;\n        height: 315px;\n        border-radius: 10px;\n        padding: 15px;\n        padding-bottom: 10px;\n        padding-top: 10px;\n    }\n    .project.active .project-name {\n        margin-bottom: 10px;\n    }\n    .by-date {\n        min-width: 220px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
